import React from "react";
import i18n from "i18next";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getWindow } from "ssr-window";

import { api } from "@/utils/api";
import url from "@/utils/url";
import { authStateEnum } from "@/utils/enum";
import { isPOC } from "@/utils";
import { updateAgreementStatusInfo as updateAgreementStatusInfoDispatch } from "@/models/user";
import ConfirmHeader from "@/react-components/Confirm/Header";
import ConfirmBody from "@/react-components/Confirm/Body";
import ConfirmTips from "@/react-components/Confirm/Tips";
import ConfirmDiffBody from "@/react-components/Confirm/DiffBody";

class ConfirmAgreementSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: null };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { state } = this.props;
    const name =
      state === authStateEnum.notCertified
        ? "getNoLoginProtocal"
        : "getLoginProtocal";
    api.agreement[name](
      state === authStateEnum.notCertified ? {} : { isSubUser: true }
    )
      .then((response) => {
        const list =
          state === authStateEnum.notCertified ? response : response?.list;
        if (list && list.length > 0) {
          this.setState({
            data: { content: list.find((item) => item.isPublish) },
            secureToken: response?.secureToken,
          });
        }
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  next = () => {
    const {
      history: { push },
      updateAgreementStatusInfo,
      state,
      authentication,
    } = this.props;
    if (state === authStateEnum.notCertified) {
      getWindow().sitecoreExternal &&
        (getWindow().sitecoreExternal.isRegisterConfirm = true);
      push(url.confirmPrivacyPolicy);
    } else {
      const { data } = this.state;
      const content = data?.content;
      if (isPOC()) {
        updateAgreementStatusInfo({
          agreementStatusInfo: {
            termsAgreementInfo: {
              termsOfServiceVer: "1.0",
              privacyPolicyVer: "",
              contactFeatureVer: "",
              bmSupportPlanTermsOfServiceVer: "",
            },
          },
        });
      } else {
        api.agreement
          .updateLoginProtocal({
            userid: authentication?.accountId,
            secureToken: data?.secureToken,
            version: content?.version,
          })
          .then((response) => {
            api.user.getAgreementStatus().then((response1) => {
              updateAgreementStatusInfo({ agreementStatusInfo: response1 });
            });
          })
          .catch((error) => {
            console.error("error: " + error.message);
          });
      }
    }
  };

  render() {
    const { data } = this.state;
    const content = data?.content;
    return (
      <div className="confirm-agreement-container">
        <ConfirmHeader />
        {content ? (
          <React.Fragment>
            {!content.isPublish && (
              <React.Fragment>
                <ConfirmTips
                  className="confirm-agreement-container-tips"
                  text={moment(content.updateDate).format(
                    i18n.t("TCCs0019_confirm_agreement_tips")
                  )}
                />
                <ConfirmDiffBody
                  className="confirm-agreement-container-diff-body"
                  title={i18n.t("TCCs0019_confirm_agreement_diff_title")}
                  data={content}
                />
              </React.Fragment>
            )}
            <ConfirmBody
              className="confirm-agreement-container-body"
              title={i18n.t("TCCs0019_confirm_agreement_content_title")}
              date={
                !content.isPublish &&
                moment(content.updateDate).format(i18n.t("common_date_after"))
              }
              content={content.contentText}
              checkboxText={i18n.t("TCCs0019_confirm_agreement_checkbox_title")}
              onClick={this.next}
              // 課金-ADD-START
              downloadUrl={i18n.t("agreement_applicable_version_download_url")}
              // 課金-ADD-END
            />
          </React.Fragment>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state: state?.user?.authState,
    authentication: state?.user?.authentication,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAgreementStatusInfo: (action) =>
      dispatch(updateAgreementStatusInfoDispatch(action)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ConfirmAgreementSection));
